module.exports = __webpack_public_path__ + "img/landing-3-shape-2.3d44c044.svg";